<div class="flex flex-col">
  <mat-label class="flex flex-row items-center gap-2" [ngClass]="labelClass">
    {{ label | translate }}
    <span *ngIf="required">*</span>
    <app-icon
      *ngIf="infoTooltip"
      class="cursor-pointer"
      [matTooltip]="infoTooltip | translate"
      iconName="info"
      size="sm"
      fill="#1f5792"
      matTooltipPosition="above"></app-icon>
  </mat-label>

  <mat-form-field color="warn" [ngClass]="{ 'mat-form-field-invalid': control?.invalid && control?.touched }">
    <textarea matInput [value]="value" (input)="onInput($event)" (blur)="onBlur()"></textarea>
  </mat-form-field>

  <ng-container *ngIf="errorMessage; else flowValidationErrors">
    <mat-error [class]="errorMessageClass" *ngIf="control?.invalid && control?.touched">
      {{ errorMessage | translate }}
    </mat-error>
  </ng-container>
  <ng-template #flowValidationErrors>
    <mat-error flowValidationErrors *ngIf="control?.invalid && control?.touched"></mat-error>
  </ng-template>
</div>
